import {useEffect, useState} from 'react'
import {Editor} from 'react-draft-wysiwyg'
import {EditorState, ContentState, convertFromHTML, convertFromRaw, convertToRaw} from 'draft-js'
import draftToHtml from 'draftjs-to-html'

type Props = {
  defaultValue?: string
  minHeight?: string
  handleGetValueFromEditor?: (data: string) => void
}

const TextEditorCustom = ({defaultValue, handleGetValueFromEditor, minHeight}: Props) => {
  const [editorState, setEditorState] = useState<EditorState | undefined>(undefined)

  const onEditorStateChange = (evt: EditorState) => {
    setEditorState(evt)
  }

  const handleBlurInput = () => {
    if (editorState) {
      let convert = draftToHtml(convertToRaw(editorState.getCurrentContent())).toString()
      if (handleGetValueFromEditor) handleGetValueFromEditor(convert)
    }
  }

  useEffect(() => {
    if (defaultValue) {
      const blocksFromHTML = convertFromHTML(defaultValue)
      const editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)
      )
      setEditorState(editorState)
    } else {
      setEditorState(undefined)
    }
  }, [defaultValue])

  return (
    <>
      <Editor
        editorState={editorState}
        toolbarClassName='toolbarClassName'
        wrapperClassName='wrapperClassName'
        editorClassName='editorClassName'
        onEditorStateChange={onEditorStateChange}
        toolbar={{
          options: [
            'inline',
            'fontSize',
            'list',
            'textAlign',
            'colorPicker'
          ],
        }}
        onBlur={handleBlurInput}
        editorStyle={{minHeight: minHeight ? minHeight : '120px', border: '1px solid #F1F1F1', maxHeight: '200px', overflow: 'auto'}}
      />
    </>
  )
}

export {TextEditorCustom}
